import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../DataCollection/style.css";
import SHARING_MAP from "./sharing_map";
import TODIS_FORM_FILTER_ADVANCE from "./advance_form_filter";

const Sharing_Advance = ({type}) => {

    const [fullMap, setfullMap] = useState(false);
    const [filterData, setfilterData] = useState({});

    const expanding = () => {
        //console.log("expanding from parent");
        setfullMap(!fullMap);
    }

    const sendFilterData = (data) => {
        //console.log("data");
        setfilterData(data);
    }

    return (
        <div className="px-4 pt-4 pb-0 row sassy-theme">
            <Container fluid className="col-sm-12">
                <TODIS_FORM_FILTER_ADVANCE expanding={expanding} fullMap={fullMap} sendFilterData={sendFilterData}/>
            </Container>
        </div>
    );
}

export default Sharing_Advance;